export default __webpack_public_path__ + "static/media/navAppIcon.9f994640.svg";